import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormControlComponent, IconComponent, ModalBaseContainerComponent } from '@frogo-kit/core';


@NgModule({
  declarations: [ChangePasswordComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,

    IconComponent,
    FormControlComponent,
    ModalBaseContainerComponent,
  ],
})
export class ChangePasswordModule {}
